import { $api } from "@/lib/api";

interface Organization {
  referenceId: string;
  name: string;
  customerNames: string[];
}

interface UseUserOrganizationsReturn {
  currentOrganization: Organization | null;
  organizations: Organization[];
  isLoading: boolean;
}

const normalizeOrganization = (org: Organization): Organization => ({
  ...org,
  customerNames: org.customerNames ?? [],
});

export const useUserOrganizations = (): UseUserOrganizationsReturn => {
  const { data, isLoading } = $api.useQuery(
    "get",
    "/v1/users/me/organizations",
  );

  const organizations = (data?.organizations ?? []).map(normalizeOrganization);

  const currentOrganization = data?.currentOrganization
    ? normalizeOrganization(data.currentOrganization)
    : null;

  return {
    currentOrganization,
    organizations,
    isLoading,
  };
};
